import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Globals } from './../../globals'
import { environment } from './../../../environments/environment';
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-validate-email',
  templateUrl: './validate-email.component.html'
})
export class ValidateComponent {
  public email;
  public tipotramites;
  public numeroserial;
  public checkAceptacion;
  public errorMessage;
  public postId;
  public idimport;
  public respuesta;
  public token;
  public lenguajeGlobal;
  public urlTree;

  public emailValidator: EmailValidator;
  public import: Import;
  public imports: Import[];
  public extend: Extend;
  public extends: Extend[];
  public session: SessionTourist;

  inactiveButton: boolean = true;
  activeButton: boolean = false;
  showModalBox: boolean = false;
  showModalRequired: boolean = false;
  showErrorCode: boolean = false;
  showReenvio: boolean = false;
  showModal: boolean = false;
  continuar: boolean = false;
  private emailPattern: any = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


  emailForm = this.formBuilder.group({
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
    idTramites: new FormControl('', [Validators.required]),
    numeroIdentificacion: new FormControl('', [Validators.required, Validators.maxLength(40)]),
    codVerificacion: new FormControl(''),
    customTarget: new FormControl(''),
    checkAccept: new FormControl('', [Validators.required])
    //closeModal: new FormControl(''),
    //hideModalForm: new FormControl('')
  });

  constructor(private http: HttpClient, private formBuilder: FormBuilder, private router: Router, private cookies: CookieService, private globals: Globals) {
    this.postId = "";
    this.emailForm.controls["customTarget"].setValue("default");
    this.urlTree = this.router.parseUrl(this.router.url);
    this.globals.path = this.urlTree.root.children.primary.segments[0].path;
    this.cookies.set("pathTurista", this.urlTree.root.children.primary.segments[0].path);
    var token = this.cookies.get("tokensessionTurista");
    var lenguaje = this.cookies.get("lenguajeTurista");
    this.lenguajeGlobal = lenguaje;
    if (token != "") {
      this.tipotramites = this.cookies.get("tipotramite");
      this.idimport = this.cookies.get("idimport");
      this.email = this.cookies.get("email");
      this.numeroserial = this.cookies.get("numeroserial");

      var tipo = (this.tipotramites == 1 ? "consulta" : (this.tipotramites == 2 ? "solicitud" : "prorroga"));

      if (this.tipotramites == 3) {
        this.router.navigate(["/extension/" + "solicitud" + "/" + this.idimport]);
      }
      else if (this.tipotramites == 2) {
        this.router.navigate(["/import-request/" + tipo + "/" + this.email + "/" + this.numeroserial + "/0/validate-email"]);

      } else if (this.tipotramites == 1) {
        this.router.navigate(["/history-import/" + this.email + "/" + this.numeroserial]);
      }
    }
  }

  //Getters
  get emailValue() { return this.emailForm.get('email'); }
  get idTramitesValue() { return this.emailForm.get('idTramites'); }
  get numeroIdentificacionValue() { return this.emailForm.get('numeroIdentificacion'); }
  get checkAcceptValue() { return this.emailForm.get('checkAccept'); }
  get customTargetValue() { return this.emailForm.get('customTarget'); }
  //get closeModalValue() { return this.emailForm.get('closeModal'); }
  //get hideModalFormValue() { return this.emailForm.get('hideModalForm'); }

  validateEmail() {
    var lenguaje = this.cookies.get("lenguajeTurista");
    this.lenguajeGlobal = lenguaje;
    this.email = this.emailForm.controls["email"].value;
    this.tipotramites = this.emailForm.controls["idTramites"].value;
    this.numeroserial = this.emailForm.controls["numeroIdentificacion"].value;
    this.checkAceptacion = this.emailForm.controls["checkAccept"].value;
    this.showModalBox = false;      
    this.showModalRequired = false;


    if (this.emailForm.valid) {
      //this.showModalBox = false;      
      //this.showModalRequired = false;
      this.emailForm.controls["customTarget"].setValue("verificationCode");

      if (this.tipotramites == 1) {
        this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + this.email + "&numeroserial=" + this.numeroserial + "&status=&passportnumber=&importdate=&idimport=&approvednumber=&sectionaladdresin=")
          .subscribe({
            next: data => {
              this.imports = data as Import[];
              if (this.imports.length > 0) {
                this.continuar = true;
                this.showModalBox = true;
                this.http.get<any>(`${environment.baseUrl}v1/token/1`)
                  .subscribe({
                    next: data => {
                      this.emailValidator = data as EmailValidator;
                      const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
                      //Consume of service
                      this.http.post<string>(`${environment.baseUrl}v1/emailvalidator`, { email: this.email, token: this.emailValidator.token }, { headers })
                        .subscribe({
                          next: data => {
                            //this.postId = data;
                          },
                          error: error => {
                            this.errorMessage = error.message;
                          }
                        })
                    },
                    error: error => {
                      this.errorMessage = error.message;
                    }
                  })
              }
              else {
                this.continuar = false;
                this.showModalRequired = true;                
                if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                  this.errorMessage = "No se ha encontrado ninguna solicitud vigente con los datos ingresados";
                } else {
                  this.errorMessage = "No current application has been found with the data entered";
                }
                
              }              
            },
            error: error => {
              this.errorMessage = error.message;
            }
          })
      }

      if (this.tipotramites == 2) {
        this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + this.email + "&numeroserial=" + this.numeroserial + "&status=1,2,3,4,5,6&passportnumber=&importdate=&idimport=&approvednumber=&sectionaladdresin=")
          .subscribe({
            next: data => {
              this.imports = data as Import[];
              this.import = this.imports[0];
              if (this.import == null) {
                this.continuar = true;
                this.showModalBox = true;
                this.http.get<any>(`${environment.baseUrl}v1/token/1`)
                  .subscribe({
                    next: data => {
                      this.emailValidator = data as EmailValidator;
                      const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
                      //Consume of service
                      this.http.post<string>(`${environment.baseUrl}v1/emailvalidator`, { email: this.email, token: this.emailValidator.token }, { headers })
                        .subscribe({
                          next: data => {
                            //this.postId = data;
                          },
                          error: error => {
                            this.errorMessage = error.message;
                          }
                        })
                    },
                    error: error => {
                      this.errorMessage = error.message;
                    }
                  })
              }
              else {
                this.continuar = false;
                this.showModalRequired = true;
                if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                  this.errorMessage = "Ya existe una solicitud de importación abierta con los parámetros ingresados";
                } else {
                  this.errorMessage = "There is already an open import request with the parameters entered";
                }
                
              }              
            },
            error: error => {
              this.errorMessage = error.message;
            }
          })
      }

      if (this.tipotramites == 3) {
        this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + this.email + "&numeroserial=" + this.numeroserial + "&status=2,5&passportnumber=&importdate=&idimport=&approvednumber=&sectionaladdresin=")
          .subscribe({
            next: data => {
              this.imports = data as Import[];
              this.import = this.imports[0];
              if (this.import != null) {
                this.idimport = this.import.id
                this.http.get<any>(`${environment.baseUrl}v1/extend/1?idImport=` + this.import.id + "&sectionaladdress=&status=4&idextend=")
                  .subscribe({
                    next: data => {
                      this.extends = data as Extend[];
                      this.extend = this.extends[0];
                      if (this.extend == null) {
                        this.continuar = true;
                        this.showModalBox = true;
                        this.http.get<any>(`${environment.baseUrl}v1/token/1`)
                          .subscribe({
                            next: data => {
                              this.emailValidator = data as EmailValidator;
                              const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
                              //Consume of service
                              this.http.post<string>(`${environment.baseUrl}v1/emailvalidator`, { email: this.email, token: this.emailValidator.token }, { headers })
                                .subscribe({
                                  next: data => {
                                    //this.postId = data;
                                  },
                                  error: error => {
                                    this.errorMessage = error.message;
                                  }
                                })
                            },
                            error: error => {
                              this.errorMessage = error.message;
                            }
                          })
                      }
                      else {
                        this.continuar = false;
                        this.showModalRequired = true;
                        if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                          this.errorMessage = "Ya existe una solicitud de prorroga abierta con los parámetros ingresados";
                        } else {
                          this.errorMessage = "There is already an open extension request with the parameters entered";
                        }
                        
                      }
                    },
                    error: error => {
                      this.errorMessage = error.message;
                      //console.error('There was an error!', error);
                    }
                  })
              }
              else {
                this.continuar = false;
                this.showModalRequired = true;
                if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
                  this.errorMessage = "No se ha encontrado ninguna solicitud vigente con los datos ingresados para solicitar una prorroga";
                } else {
                  this.errorMessage = "No current application has been found with the data entered to request an extension";
                }
                
              }
              
            },
            error: error => {
              this.errorMessage = error.message;
            }
          })
      }
            
    } else {
      this.showModalRequired = true;
      this.emailForm.controls["customTarget"].setValue("modalValidationErrors");
      this.showErrorMessages();
    }
  }

  validateCode() {    
    //this.emailForm.controls["hideModalForm"].setValue("default");
    this.showErrorCode = false;
    this.showReenvio = false;
    var tipo = (this.tipotramites == 1 ? "consulta" : (this.tipotramites == 2 ? "solicitud" : "prorroga"));
    this.postId = this.emailForm.controls["codVerificacion"].value;

    if (this.postId != "") {
      const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
      this.http.get<any>(`${environment.baseUrl}v1/token/1`)
        .subscribe({
          next: data => {
            this.emailValidator = data as EmailValidator;
            //Consume of service
            this.http.put<EmailValidator>(`${environment.baseUrl}v1/emailvalidator/` + this.postId, { id: this.postId, email: this.email, token: this.emailValidator.token }, { headers })
              .subscribe({
                next: data => {
                  this.respuesta = data.status;
                  if (this.respuesta == "FALLIDO") {
                    this.showErrorCode = true;
                    this.showReenvio = false;
                  } else {
                    this.session = new SessionTourist;
                    this.session.email = this.email;
                    this.session.chassisNumber = this.numeroserial;
                    const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
                    this.http.post<string>(`${environment.baseUrl}v1/sessiontourist`, this.session, { headers })
                      .subscribe({
                        next: data => {
                          this.cookies.set("tokensessionTurista", data, 1, environment.raiz, environment.dominio,false,"Lax");
                          this.cookies.set("tipotramite", this.tipotramites, 1, environment.raiz, environment.dominio, false, "Lax");
                          this.cookies.set("idimport", this.idimport, 1, environment.raiz, environment.dominio, false, "Lax");
                          this.cookies.set("email", this.email, 1, environment.raiz, environment.dominio, false, "Lax");
                          this.cookies.set("numeroserial", this.numeroserial, 1, environment.raiz, environment.dominio, false, "Lax");

                          this.showErrorCode = false;
                          this.showReenvio = false;
                          this.showModal = true;
                          if (this.tipotramites == 3) {
                            let element: HTMLElement = document.getElementById('cerrarmodal') as HTMLElement;
                            element.click();
                            this.router.navigate(["/extension/" + "solicitud" + "/" + this.idimport + "/0"]);
                          }
                          else if (this.tipotramites == 2) {
                            let element: HTMLElement = document.getElementById('cerrarmodal') as HTMLElement;
                            element.click();
                            this.router.navigate(["/import-request/" + tipo + "/" + this.email + "/" + this.numeroserial + "/0/validate-email"]);

                          } else if (this.tipotramites == 1) {
                            let element: HTMLElement = document.getElementById('cerrarmodal') as HTMLElement;
                            element.click();
                            this.router.navigate(["/history-import/" + this.email + "/" + this.numeroserial]);
                          }
                        },
                        error: error => {
                        }
                      })
                    

                  }
                },
                error: error => {
                  this.errorMessage = error.message;
                  //console.error('There was an error!', error);
                }
              })
          },
          error: error => {
            this.errorMessage = error.message;
          }
        })
    }
    else {
      this.showErrorCode = true;
      this.showReenvio = false;
    }    
  }

  showErrorMessages() {
    if (this.email == '' || this.tipotramites == '' || this.numeroserial == '' || this.checkAceptacion == false) {
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.errorMessage = "Datos obligatorios sin diligenciar";
      } else {
        this.errorMessage = "Obligatory data without filling out";
      }
      
    }
    if (this.emailValue.dirty && !this.emailValue.valid) {
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.errorMessage = "Correo electrónico incorrecto";
      } else {
        this.errorMessage = "Wrong email";
      }
      
    }
    if (this.respuesta == "FALLIDO") {
      if (this.lenguajeGlobal == "" || this.lenguajeGlobal == "es") {
        this.errorMessage = "El código de verificación no coincide con el enviado";
      } else {
        this.errorMessage = "The verification code does not match the one sent";
      }
      
    }
  }

  activButton() {
    this.checkAceptacion = this.emailForm.controls["checkAccept"].value;
    if (this.checkAceptacion == true) {
      this.inactiveButton = false;
      this.activeButton = true;
    }
    else {
      this.inactiveButton = true;
      this.activeButton = false;
    }
  }

  terminos() {
    this.router.navigate(["/personal-data"]);
  }

  reenviar() {
    this.showErrorCode = false;
    this.showReenvio = false;
    const headers = { 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE', 'Allow': 'GET, POST, OPTIONS, PUT, DELETE', 'Content-Type': 'application/json' };
    this.http.post<string>(`${environment.baseUrl}v1/emailvalidator`, { email: this.email, token: this.emailValidator.token }, { headers })
      .subscribe({
        next: data => {
          this.showReenvio = true;
        },
        error: error => {
          this.errorMessage = error.message;
        }
      })
  }
}

interface EmailValidator {
  id: number;
  email: string;
  status: string;
  date: any;
  token: string;
}

class Import {
  id: string;
  //sectionalAddressIn: string;
  //sectionalAddressOut: string;
  //touristName: string;
  //touristCountry: string;
  //passportNumber: string;
  //nationality: string;
  //dateOfArrival: string;
  //touristCity: string;
  //touristAddress: string;
  //authorizedDuration: string;
  //email: string;
  //dateIn: string;
  //dateOut: string;
  //vehicleEntryForm: string;
  //transportDocumentNumber: string;
  //n1166DocumentNumber: string;
  //ownershipDocumentNumber: string;
  //registrationDate: string;
  //typeClass: string;
  //chassisNumber: string;
  //licensePlate: string;
  //make: string;
  //model: string;
  //engineNumber: string;
  //countryOfRegistration: string;
  //color: string;
  //transportationName: string;
  //nameFlag: string;
  //entryPlace: string;
  //registrationNumber: string;
  //transportationChars: string;
  //othersChars: string;
  //idStatus: string;
  //importDate: string;
}

class Extend {
  id: string;
  //sectionalAddress: string;
  //authorizedDuration: string;
  //initialDate: string;
  //endDate: string;
  //touristCity: string;
  //touristAddress: string;
  //justification: string;
  //authorization: string;
  //tIDAssignee: string;
  //iDAssignee: string;
  //nameAssignee: string;
  //emailAssignee: string;
  //registrationDate: string;
  //idImport: string;
  //idStatus: string;
}

class SessionTourist {
  id: string;
  email: string;
  chassisNumber: string;
  token: string;
  date: string;
}
